import { Link } from "react-router-dom";
import { imgSrc } from "@/lib/img";

const StockBadge = ({ stock }) => {
  if (stock === 0) {
    return (
      <span data-testid="badge-sold-out" className="absolute top-3 left-3 bg-[#2D2626] text-[#FAFAF7] text-[10px] uppercase tracking-[0.25em] px-3 py-1.5">
        Sold Out
      </span>
    );
  }
  if (stock <= 5) {
    return (
      <span data-testid="badge-low-stock" className="absolute top-3 left-3 bg-[#D4AF37] text-[#2D2626] text-[10px] uppercase tracking-[0.25em] px-3 py-1.5">
        Only {stock} left
      </span>
    );
  }
  return null;
};

export const ProductCard = ({ product }) => {
  const img = imgSrc(product.images?.[0] || "");
  const soldOut = product.stock === 0;
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block"
    >
      <div className="relative img-zoom aspect-[3/4] bg-[#F3EFEA] mb-4">
        {img && <img src={img} alt={product.name} className={`w-full h-full object-cover ${soldOut ? "opacity-60" : ""}`} loading="lazy" />}
        <StockBadge stock={product.stock} />
        {product.featured && !soldOut && product.stock > 5 && (
          <span data-testid="badge-featured" className="absolute top-3 right-3 bg-[#6B1A24] text-[#FAFAF7] text-[10px] uppercase tracking-[0.25em] px-3 py-1.5">
            Featured
          </span>
        )}
      </div>
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="label-eyebrow">{product.category}</div>
          <h3 className="font-display text-lg md:text-xl mt-1 leading-tight">{product.name}</h3>
        </div>
        <div className="font-display text-lg md:text-xl tabular-nums">${product.price.toFixed(0)}</div>
      </div>
    </Link>
  );
};

export default ProductCard;
